import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { DEFAULT_MARQUEE_SPEED_RATE, MARQUEE_SPEED_RATES, Mode } from '@core/constants';
import { DropdownOption } from '@core/models/models';
import { Observable, Subject } from 'rxjs';
import { CommonHelper } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class MarqueeSpeedService {
  private speedRateSubject: Subject<number> = new Subject<number>();

  // tốc độ dùng chung cho tất cả テロップ của tất cả màn hình
  get speedRate$(): Observable<number> {
    return this.speedRateSubject.asObservable();
  }

  getSpeedRate(): number {
    const storedRate = Number(CommonHelper.getScreenConfigByOfficeCd()?.[LOCAL_STORAGE_KEY.marqueeSpeedRate]);
    return MARQUEE_SPEED_RATES.includes(storedRate) ? storedRate : DEFAULT_MARQUEE_SPEED_RATE;
  }

  setSpeedRate(speedRate: any, mode: Mode = Mode.WEB): void {
    const rate = Number(speedRate);
    const validRate = MARQUEE_SPEED_RATES.includes(rate) ? rate : DEFAULT_MARQUEE_SPEED_RATE;
    const officeConfig = CommonHelper.getScreenConfigByOfficeCd() ?? {};
    CommonHelper.setScreenConfigByOfficeCd({
      ...officeConfig,
      [LOCAL_STORAGE_KEY.marqueeSpeedRate]: validRate,
    }, mode);
    this.speedRateSubject.next(validRate);
  }

  getSpeedOptions(): DropdownOption[] {
    return MARQUEE_SPEED_RATES.map(rate => new DropdownOption(this.getSpeedLabel(rate), `${rate}`));
  }

  private getSpeedLabel(rate: number): string {
    return `${rate.toFixed(1)}×`;
  }
}
